import type { July4848PromoVariant } from '~/features/promotions/constants/july-48-48-promo';

import type { PromoCampaignSurfaceRenderers, RegisteredPromoCampaign } from '../types';

import { july4848PromoCampaignCore } from './campaign-core';
import { july4848PromoCampaignSurfaces } from './surfaces';

export { JULY_48_48_PROMO_CAMPAIGN_ID, july4848PromoCampaignCore } from './campaign-core';

const july4848PromoCampaignTyped = {
  ...july4848PromoCampaignCore,
  surfaces: july4848PromoCampaignSurfaces,
} satisfies PromoCampaignSurfaceRenderers<July4848PromoVariant>;

export const july4848PromoCampaign = july4848PromoCampaignTyped as RegisteredPromoCampaign;
